import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addAnnounce, upAnnounceNew } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    serverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      paramsData: {
        id: '',
        label: '',
        server_rangeStart: '',
        server_rangeEnd: ''
      },
      dialogShow: false,
      rules: {
        title: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }],
        label: [{
          required: true,
          message: "请输入标识",
          trigger: "blur"
        }],
        priority: [{
          required: true,
          message: "请输入优先值",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      if (data) {}

      this.dialogShow = true;
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        id: isClearId ? '' : this.paramsData.id,
        label: '',
        server_rangeStart: '',
        server_rangeEnd: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this.paramsData.id !== '' ? upAnnounceNew : addAnnounce;
          reqFn(_objectSpread(_objectSpread({}, _this.paramsData), _this.prod)).then(function (res) {
            if (res.status == 200) {
              _this.$message({
                message: '操作成功',
                type: 'success'
              });

              _this.dialogShow = false;

              _this.$emit('update');
            }
          });
        }
      });
    }
  }
};